module.exports = "/images/logo_navbar.png?84bcd4e0a7e01b09158ef6c16cbb53f8";